import { render, staticRenderFns } from "./WorkDays.vue?vue&type=template&id=15b2605e&scoped=true"
import script from "./WorkDays.vue?vue&type=script&lang=js"
export * from "./WorkDays.vue?vue&type=script&lang=js"
import style0 from "./WorkDays.vue?vue&type=style&index=0&id=15b2605e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b2605e",
  null
  
)

export default component.exports